export interface ILSICalculationRequestModel {
    waterTemperatureCurrentF: number | null;
    phCurrent: number | null;
    totalAlkalinityCurrent: number | null;
    calciumCurrent: number | null;
    chlorineCurrent: number | null;
    cyaCurrent: number | null;
    saltCurrent: number | null;
    boratesCurrent: number | null;
    phosphateCurrent: number | null
    waterTemperatureDesiredF: number | null;
    phDesired: number | null;
    totalAlkalinityDesired: number | null;
    calciumDesired: number | null;
    cyaDesired: number | null;
    chlorineDesired: number | null;
    saltDesired: number | null;
    boratesDesired: number | null;
    phosphateDesired: number | null
}

export class LSICalculationRequestModel implements ILSICalculationRequestModel {
    waterTemperatureCurrentF: number | null = null;
    phCurrent: number | null = null;
    totalAlkalinityCurrent: number | null = null;
    calciumCurrent: number | null = null;
    cyaCurrent: number | null = null;
    chlorineCurrent: number | null;
    saltCurrent: number | null = null;
    boratesCurrent: number | null = null;
    phosphateCurrent: number | null
    waterTemperatureDesiredF: number | null = null;
    phDesired: number | null = null;
    totalAlkalinityDesired: number | null = null;
    calciumDesired: number | null = null;
    cyaDesired: number | null = null;
    chlorineDesired: number | null;
    saltDesired: number | null = null;
    boratesDesired: number | null = null;
    phosphateDesired: number | null

    constructor(init?: Partial<LSICalculationRequestModel>) {
        Object.assign(this, init);
    }
}
